<template>
    <div>
        <div
            v-if="!$wait.is('loading-page') && !notFound"
            class="m-case-study"
        >
            <div class="m-case-study--single__hero">
                <y-container v-if="caseStudy">
                    <y-case-study-hero
                        :content="caseStudy"
                        :album="caseStudy['albums'] ? caseStudy['albums'][0] : null"
                    />
                </y-container>
            </div>

            <y-container v-if="caseStudy">
                <y-case-study-body
                    :content="caseStudy['custom']"
                    :content-text="caseStudy['text']"
                    :albums="caseStudy['albums']"
                />
            </y-container>
        </div>
        <page-not-found v-if="notFound" />
    </div>
</template>

<script>
    import PageMixin from '@groot-nodes/mixins/Page.js';

    // Components
    import YCaseStudyHero from '@modules/case-studies/components/HeroSingle/Index.vue';
    import YCaseStudyBody from '@modules/case-studies/components/Body/Index.vue';
    import PageNotFound from '@components/PageNotFound.vue';

    export default {
        name: 'CaseStudySinglePage',

        components: {
            PageNotFound,
            YCaseStudyHero,
            YCaseStudyBody,
        },

        mixins: [PageMixin],

        /**
         * @inheritDoc
         */
        data() {
            return {
                caseStudy  : null,
                notFound   : false,
                heroContent: '',
            };
        },
        /**
         * @inheritDoc
         */
        metaInfo() {
            return {
                title: this.heroContent.seo_post_title,

                meta: [
                    {
                        vmid   : 'description',
                        name   : 'description',
                        content: this.heroContent.seo_meta_description,
                    },
                ],
            };
        },

        methods: {
            /**
             * Fetch case studies data
             *
             * @returns {Promise}
             */
            fetch() {
                const caseStudy = this.$services.Content.postSingle({
                    type     : 'case-studies',
                    including: ['title', 'synopsis', 'image', 'text', 'custom', 'url_encode', 'albums', 'seo_canonical', 'seo_meta_description', 'seo_post_title'],
                    slug     : this.$route.params.slug,
                    locale   : this.$i18n.locale,
                }).catch((error) => {
                    if (error.response.data.status === '404') {
                        this.notFound = true;
                    }
                    this.handleError(error);
                });

                return Promise.all([caseStudy]).then((responses) => {
                    if (this.handleReq(responses, 0)) {
                        this.caseStudy = responses[0].data.results;
                        this.heroContent = this.caseStudy;
                    }
                }).catch((error) => {
                    this.handleError(error);
                });
            },
        },
    };
</script>

<style lang="scss" src="../scss/case-studies.scss" />
